import { useCallback, useState } from 'react'

import { GroupingState } from './useTableGrouping.types'

export const useGroupingControls = (): GroupingState => {
  const [collapsedCategories, setCollapsedCategories] = useState<
    Map<string, boolean>
  >(new Map())
  const [isAllCollapsed, setIsAllCollapsed] = useState<boolean>(false)

  const toggleCategory = useCallback((categoryId: string) => {
    setCollapsedCategories(prev => {
      const newMap = new Map(prev)
      const isCollapsed = newMap.get(categoryId)
      newMap.set(categoryId, !isCollapsed)
      return newMap
    })
  }, [])

  const collapseAll = useCallback((categoryIds: string[]) => {
    setCollapsedCategories(prev => {
      const newMap = new Map(prev)
      categoryIds.forEach(id => newMap.set(id, true))
      return newMap
    })
    setIsAllCollapsed(true)
  }, [])

  const expandAll = useCallback((categoryIds: string[]) => {
    setCollapsedCategories(prev => {
      const newMap = new Map(prev)
      categoryIds.forEach(id => newMap.set(id, false))
      return newMap
    })
    setIsAllCollapsed(false)
  }, [])

  const reset = useCallback(() => {
    setCollapsedCategories(new Map())
    setIsAllCollapsed(false)
  }, [])

  return {
    collapsedCategories,
    toggleCategory,
    isAllCollapsed,
    collapseAll,
    expandAll,
    reset,
  }
}
